export default __webpack_public_path__ + "static/homepage-pottery-a5f138a55d106177e672d72c92490cfa.png";